// コースIDとレッスンNOの組に対してユニーク化をするため、
// 2つを結合した文字列を生成する
export const makeCourseIdLessonNoTag = (courseId: string, lessonNo: number) => {
    return `${courseId}|${lessonNo}`;
}
